<template>
<div class="chapter">
<div class="inner_page">
<p class="TOCH_Table_of_Contents_main_head">Contents</p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/cover" title="Link target outside of Sample">Cover</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><a class="toc-link" href="#/xhtml/alsoby">Titles by Simon Beaufort from Severn House</a></p>
<p class="TOC1_Table_of_Contents_entry_1"><a class="toc-link" href="#/xhtml/title">Title Page</a></p>
<p class="TOC1_Table_of_Contents_entry_1"><a class="toc-link" href="#/xhtml/copyright">Copyright</a></p>
<p class="TOC1_Table_of_Contents_entry_1"><a class="toc-link" href="#/xhtml/dedication">Dedication</a></p>
<p class="TOC1_Table_of_Contents_entry_1_SA"><a class="toc-link" href="#/xhtml/map">Map</a></p>
<p class="TOC1_Table_of_Contents_entry_1_SA"><a class="toc-link" href="#/xhtml/prologue">Prologue</a></p>
<p class="TOC1_Table_of_Contents_entry_1"><a class="toc-link" href="#/xhtml/chapter001">Chapter One</a></p>
<p class="TOC1_Table_of_Contents_entry_1"><a class="toc-link" href="#/xhtml/chapter002">Chapter Two</a></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter003" title="Link target outside of Sample">Chapter Three</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter004" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter005" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter006" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter007" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter008" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter009" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter010" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter011" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter012" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter013" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter014" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/chapter015" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="TOC1_Table_of_Contents_entry_1_SA"><span class="toc-link" href="#/xhtml/chapter016" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="TOC1_Table_of_Contents_entry_1"><span class="toc-link" href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?de4a20be